import { render, staticRenderFns } from "./ManageCDP.vue?vue&type=template&id=31d5b677&scoped=true&"
import script from "./ManageCDP.vue?vue&type=script&lang=js&"
export * from "./ManageCDP.vue?vue&type=script&lang=js&"
import style0 from "./ManageCDP.vue?vue&type=style&index=0&id=31d5b677&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d5b677",
  null
  
)

export default component.exports